import React, { useState, ReactNode } from "react";
import Tag from "../../../../../generic/tag";
import { INcd } from "../../../../../types/components/orderBook/obTypes";
import { ChipColorKeyComb, ObScrollStyle } from "../../../obConstants";
import { HObGroupBy } from "../../../../../service/orderBook/obGrpByHelper";
import { toINR } from "../../../../../service/numberFormat";
import { ChipStatusComb } from "./../../../obConstants";
import bStrg from "../../../../../service/storageHelper";
import { obTglDetail } from "../../../../../service/orderBook/obToggler";
import { IListObj } from "../../../../../types/genericTypes";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";

export interface ObNcdProps {
	data: Array<INcd>;
	isHistory: boolean;
	noDataNode: ReactNode;
}

// heading for NCD Asset table

const heading = {
	symbol: "Symbol",
	qty: "Qty.",
	price: "Price",
	amount: "Total Value"
};
const ObNcd: React.FC<ObNcdProps> = (props) => {
	for (let i = 0; i < props.data.length; i++) {
		const element: INcd = props.data[i];
		var temp: Array<IListObj> = [];

		element.ovrOpts = temp;
	}
	// wherever initial data needs to be sent, send initialData
	// initial data is array of array for supporting grouping
	const initialData = [props.data],
		todayDate = bStrg("todayDate") || new Date();
	let [tableData, setTableData] = useState(initialData);
	let ncdData: Array<{ [x: string]: Array<INcd> }> | null = null,
		todaysNcds: Array<Array<{}>> | null = null;

	React.useEffect(() => {
		setTableData([props.data]);
	}, [props.data]);

	if (props.data) {
		//group data based on biddingEndDate
		let results = tableData.map((group: Array<any>) =>
			group.reduce(
				(arr: any, d: INcd) => {
					if (new Date(d.tmStm).setHours(0, 0, 0).valueOf() === new Date(todayDate).setHours(0, 0, 0).valueOf()) {
						arr[0] = [...arr[0], d];
					} else {
						arr[1] = [...arr[1], d];
					}
					return arr;
				},
				[[], []]
			)
		);
		if (!props.isHistory) {
			todaysNcds = results[0][0].length > 0 ? [results[0][0]] : null;
		} else {
			ncdData = results[0][1].length > 0 ? [HObGroupBy(results[0][1], "tmStm", " ")] : null;
		}
	}

	function ncdDetails(data: INcd, groupIndex: number, index: number) {
		return (
			<div className="pm_detls_con_wrapper" onClick={(e) => obTglDetail(e, ".ncd_pm_tbl", groupIndex, 1)}>
				<div className="ncd_detls_con new_offer_detls_con">
					<div className="top_sec">
						<div className="left_cont ib">
							<span className="time ib">{data.tmStm.split(" ")[1].toLowerCase().trim()}</span>
							<div className="tag_con ib">
								<Tag value="B" shape="mini_circle" color="green" height="22px" width="22px" />
							</div>
						</div>
						<div className="center_cont ib">
							<h2 className="col comp sym">{data.sym}</h2>
							<div className="col qty taRight">
								<span>{data.qty}</span>
							</div>
							<div className="col price taRight">
								<span>{data.prc ? "₹" + toINR(data.prc, 2) : "--"}</span>
							</div>
						</div>
						<div className="right_cont ib">
							<span className="amt">₹{toINR(data.amt, 2)}</span>
							<Tag value={ChipStatusComb[data.sts.toLowerCase()]} shape="chip" color={ChipColorKeyComb[data.sts.toLowerCase()]} />
						</div>
					</div>

					<div className="botm_sec">
						<div className="dtl_list ib">
							<div className="dtl_row">
								<span className="txt">Issue Type</span>
								<span className="val">{data.issTyp}</span>
							</div>
							<div className="dtl_row">
								<span className="txt">Application No.</span>
								<span className="val">{data.apNo}</span>
							</div>
							<div className="dtl_row">
								<span className="txt">Order No.</span>
								<span className="val">{data.noID}</span>
							</div>
							<div className="dtl_row">
								<span className="txt">Bid</span>
								<span className="val">{data.bNo}</span>
							</div>
							<div className="dtl_row">
								<span className="txt">Reason</span>
								<span className={"val " + (data.sts.toLowerCase().indexOf("rejected") >= 0 ? "rejected" : "")}>
									{data.msg ? data.msg : "--"}
								</span>
							</div>
						</div>
						{/* <div className="btn_con ib">
							<a href="text" className="cncl_btn btn">
								Cancel Order
							</a>
							<a href="text" className="modfy_btn btn">
								Modify Order
							</a>
						</div> */}
					</div>
				</div>
			</div>
		);
	}
	function ncdRw(data: INcd, groupIndex: number, index: number) {
		return (
			<React.Fragment key={index}>
				<li className="ncd_data ins_data" key={index} onClick={(e) => obTglDetail(e, ".ncd_pm_tbl", groupIndex, 0)}>
					<div className="col time">
						<span>{data.tmStm.split(" ")[1].toLowerCase().trim()}</span>
					</div>
					<div className="col txn_typ">
						<span>
							<Tag value="B" shape="mini_circle" color="green" height="22px" width="22px" />
						</span>
					</div>
					<div className="col sym">
						<p>{data.sym}</p>
						<p className="sym_code">{data.tSym}</p>
					</div>

					<div className="col qty taRight">
						<span>{data.qty}</span>
					</div>
					<div className="col price taRight">
						<span>{data.prc ? "₹" + toINR(data.prc, 2) : "--"}</span>
					</div>
					<div className="col amt taRight">
						<span>₹{toINR(data.amt, 2)}</span>
					</div>

					<div className="col sts">
						<span>
							<Tag value={ChipStatusComb[data.sts.toLowerCase()]} shape="chip" color={ChipColorKeyComb[data.sts.toLowerCase()]} />
						</span>
					</div>
					<div className="col menu"></div>
				</li>
				{ncdDetails(data, groupIndex, index)}
			</React.Fragment>
		);
	}
	return (
		<>
			{((ncdData !== null && props.isHistory) || (todaysNcds !== null && !props.isHistory)) && (
				<div className="ncd_pm_tbl ins_tabl">
					{/* ob NCD Header Row */}

					<ul className="hdr_row">
						<li>
							<div className="col time"> </div>
							<div className="col txn_typ"> </div>
							<div className="col sym">{heading.symbol}</div>
							<div className="col qty taRight">{heading.qty}</div>
							<div className="col price taRight">{heading.price}</div>
							<div className="col amt taRight">{heading.amount}</div>
							<div className="col sts"></div>
							<div className="col menu"></div>
						</li>
					</ul>

					{/* ob NCD content Row */}
					<div className={props.data.length > 0 ? "ObScrollCont" : ""} style={ObScrollStyle(props.data.length > 0 ? true : false)}>
						{
							props.isHistory
								? ncdData !== null &&
								  ncdData.map((group, groupIndex) =>
										Object.keys(group).map((date, GIindex) => {
											return (
												<React.Fragment key={GIindex}>
													{/* if history componenet need to show*/}

													<ul className="eq_hist_date hist_date" key={"dtGp" + GIindex}>
														<li>{date.split(",")[0]}</li>
													</ul>
													<ul key={"dtUlDet" + GIindex}>
														{group[date].map((row: any, index: number) => ncdRw(row, GIindex, index))}
													</ul>
												</React.Fragment>
											);
										})
								  )
								: todaysNcds !== null &&
								  todaysNcds.map((group: any, groupIndex: number) =>
										// Object.keys(group).map((grp: any, index) =>
										{
											return (
												<React.Fragment key={groupIndex}>
													{group.length > 0 && (
														<ul key={groupIndex} className={"blockDivider child" + groupIndex}>
															{group.map((row: any, index: number) => (
																<React.Fragment key={index}>{ncdRw(row, groupIndex, index)}</React.Fragment>
															))}
														</ul>
													)}
												</React.Fragment>
											);
										}
								  )
							// )
						}
					</div>
				</div>
			)}
			{((ncdData === null && props.isHistory) || (todaysNcds === null && !props.isHistory)) && props.noDataNode}
		</>
	);
};

export default ObNcd;
